import { useState } from 'react';
import Button from '@/components/ui/button.jsx';
import Input from '@/components/ui/input.jsx';
import { cotizarGuia } from '@/services/tarifarios.js';

export default function TarifariosPage() {
  const [form, setForm] = useState({ sucursal_id: 1, linea_id: '', cliente_id: '', kilos: 0, bultos: 0, valor_declarado: 0 });
  const [result, setResult] = useState(null);

  const onSimular = async () => {
    const data = await cotizarGuia({
      ...form,
      sucursal_id: Number(form.sucursal_id),
      linea_id: form.linea_id ? Number(form.linea_id) : null,
      cliente_id: form.cliente_id ? Number(form.cliente_id) : null,
      tipo_servicio: 'STANDARD',
      kilos: Number(form.kilos || 0),
      bultos: Number(form.bultos || 0),
      valor_declarado: Number(form.valor_declarado || 0),
      retiro: false,
      entrega: true,
      devolucion: false,
    });
    setResult(data);
  };

  return (
    <div className="space-y-4 p-4">
      <h1 className="text-xl font-semibold text-[rgb(var(--fg))]">Tarifarios inteligentes</h1>
      <div className="grid gap-2 md:grid-cols-3">
        {['sucursal_id', 'linea_id', 'cliente_id', 'kilos', 'bultos', 'valor_declarado'].map((k) => (
          <Input key={k} value={form[k]} onChange={(e) => setForm((p) => ({ ...p, [k]: e.target.value }))} placeholder={k} />
        ))}
      </div>
      <Button type="button" onClick={onSimular}>Simular cotización</Button>
      {result ? <pre className="rounded border border-[rgba(var(--border),0.4)] p-3 text-xs text-[rgb(var(--fg))]">{JSON.stringify(result, null, 2)}</pre> : null}
    </div>
  );
}
